// extracted by mini-css-extract-plugin
export default {"snackbar":"SnackProvider_snackbar__Xhqvi","alertContainer":"SnackProvider_alertContainer__r8z2s"};